module.exports = __webpack_public_path__ + "img/noCarsIn.6cf964b3.png";